import { fromJS } from 'immutable';
import * as ReducerActions from './actions';

const initialState = fromJS({
    data: {
        marcas: undefined,
        marcaEdit: undefined
    }
});

export default function marcasReducer(state = initialState, action) {
    
    if (action.type === ReducerActions.SET_MARCAS) {
        return state.setIn(["data", "marcas"], action.payload);
    }

    if (action.type === ReducerActions.SAVE_MARCA) {
        return state.setIn(["data", "marcaEdit"], action.payload);
    }

    return state;
}